// ==============================|| OVERRIDES - FORM HELPER TEXT ||============================== //

export default function FormHelperText() {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 8,
          fontSize: '14px !important',
          fontWeight: '400 !important',
          fontFamily: 'Lato'
        }
      }
    }
  };
}
